module.exports = __webpack_public_path__ + "media/images/add_to_google_pay-d8dabef631894e1be580a27646cb02e0.png";